/**
 * @description: 手机号显示前三位和后四位中间用*号
 * @author: zb
 * @update: zb
 * @Date: 2019-07-30 17:31:08
 * @LastEditors: zb
 * @LastEditTime: 2019-07-30 18:47:54
 */

const formatPhone = (value) => {
  if (value && value.length == 11) {
    return value.substring(0, 2) + '****' + value.substring(7)
  }
  return value
}

export { formatPhone }
